import { render } from "./tixian1.vue?vue&type=template&id=09fc3808&scoped=true"
import script from "./tixian1.vue?vue&type=script&lang=js"
export * from "./tixian1.vue?vue&type=script&lang=js"

import "./tixian1.vue?vue&type=style&index=0&id=09fc3808&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\记录\\2508幸运28\\xingyun_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09fc3808"]])

export default __exports__